import { styled } from 'styled-components';

export interface IProgressBarProps {
    progress?: number;
}

export function ProgressBar(props: IProgressBarProps) {
    return (
        <StyledProgressBar>
            <StyledProgress progress={props.progress} />
        </StyledProgressBar>
    );
}
const StyledProgressBar = styled.div<IProgressBarProps>`
    background-color: #ffc5fb;
    height: 5px;
    position: relative;
    z-index: 1020;

    @media screen and (min-width: 992px) {
        position: fixed;
        top: 60px;
        width: 100%;
    }
`;

const StyledProgress = styled.div<IProgressBarProps>`
    position: absolute;
    width: ${(props) => `${props.progress}%`};
    top: 0;
    left: 0;
    height: 5px;
    background-color: #cf07be;
    transition: width 0.5s;
`;
